module.exports = __webpack_public_path__ + "static/img/0547_7.1a09389.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0547_7.jpg
// module id = 6kLn
// module chunks = 1